var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 9,
    viewBox: "0 0 6 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.78352 1.50115H4.97831C5.08824 1.50115 5.17745 1.41709 5.17745 1.31351V0.187644C5.17745 0.0840646 5.08824 0 4.97831 0H3.78352C2.57598 0 1.59306 0.925836 1.59306 2.06409V3.3776H0.199133C0.0892114 3.3776 0 3.46166 0 3.56524V4.6911C0 4.79468 0.0892114 4.87875 0.199133 4.87875H1.59306V8.81928C1.59306 8.92286 1.68227 9.00692 1.79219 9.00692H2.98699C3.09691 9.00692 3.18612 8.92286 3.18612 8.81928V4.87875H4.58005C4.66568 4.87875 4.74174 4.82696 4.76923 4.7504L5.16749 3.62454C5.1878 3.56749 5.17745 3.50444 5.14001 3.45528C5.10217 3.40649 5.04243 3.3776 4.97831 3.3776H3.18612V2.06409C3.18612 1.75372 3.45415 1.50115 3.78352 1.50115Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape);
export default __webpack_public_path__ + "static/media/Shape.25ee0ba317a277c6e9c3f7f5b1ead26d.svg";
export { ForwardRef as ReactComponent };